{
  "success": true,
  "area": "technical",
  "targetLevel": 3
}
